import store from '../store'

export const authorizeToken = (to, from, next) => {
  const routeGuard = (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // マッチしたルートにおいて、メタフィールドに`requiresAuth`が付与されている場合は
      // ログインした際に付与される認証トークンがあるかどうかチェックする
      // 注意:
      // このアプリケーションでは簡略化のため`auth.token`があるかどうかのみで
      // ログイン済みであるかどうかチェックしているが、
      // 本来ならば付与された認証トークンをバックエンドのAPI経由などで検証すべき
      if (store.state.Auth.user && localStorage.getItem('token')) {
        next()
      } else {
        next({ name: 'Login' })
      }
    } else if (to.name === 'Login' && (store.state.Auth.user && localStorage.getItem('token'))) {
      next({ name: 'Top' })
    } else {
      next()
    }
  }
  if (!from.name || to.name === 'Login') {
    store.dispatch('Auth/initUser', null)
      .then(output => {
        routeGuard(to, from, next)
      })
  } else {
    routeGuard(to, from, next)
  }
}



// WEBPACK FOOTER //
// ./src/router/guards.js